import { render, staticRenderFns } from "./CoCopy.vue?vue&type=template&id=404a62dd&"
import script from "./CoCopy.vue?vue&type=script&lang=ts&"
export * from "./CoCopy.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports